import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, BoxProps, Text, Tooltip } from '@modusign/design-system';
import moment from 'moment';
import { forwardRef, ReactNode } from 'react';

import { SigningExpiryDate } from '@app/features/inPerson/types';

export default function ParticipantStatusBadge({
  hasSigned,
  isCurrentOrder,
  expiry,
}: {
  hasSigned: boolean;
  isCurrentOrder: boolean;
  expiry: SigningExpiryDate;
}) {
  if (hasSigned) {
    return (
      <LabelWrapper>
        <Box display="inline-block" fontSize="11px" height="11px" mr="2px" width="11px">
          <FontAwesomeIcon icon={faCheck as IconProp} />
        </Box>
        서명 완료
      </LabelWrapper>
    );
  }

  if (!expiry.isValid) {
    return (
      <LabelWrapper
        backgroundColor="statusBackgroundNeutralDarkest"
        borderStyle="solid"
        borderWidth="1px"
        color="textNeutralLightest"
      >
        만료 {moment(expiry.date).format('YYYY-MM-DD HH:mm')}
      </LabelWrapper>
    );
  }

  if (!isCurrentOrder) {
    return (
      <Tooltip
        content={
          <Box width="224px">
            <Text fontSize="xs" fontWeight="medium" textAlign="center">
              앞 순서의 서명자가 서명을 완료해야 해당 서명자의 대면서명을 진행할 수 있습니다.
            </Text>
          </Box>
        }
        placement="top"
      >
        <LabelWrapper
          backgroundColor="statusBackgroundNeutralLightest"
          borderColor="statusBorderNeutralBase"
          borderStyle="solid"
          borderWidth="1px"
        >
          서명 순서 대기 중
        </LabelWrapper>
      </Tooltip>
    );
  }

  return null;
}

interface LabelWrapperProps extends BoxProps<'div'> {
  children: ReactNode;
}

const LabelWrapper = forwardRef<HTMLDivElement, LabelWrapperProps>(
  ({ children, ...boxProps }: LabelWrapperProps, ref) => {
    return (
      <Box
        as="div"
        backgroundColor="statusBackgroundNeutralBase"
        borderRadius="10px"
        color="textNeutralLight"
        display="inline-block"
        fontSize="10px"
        fontWeight="medium"
        height="19px"
        lineHeight="1.4"
        pb="3px"
        pt="2px"
        px={3}
        ref={ref}
        {...boxProps}
      >
        {children}
      </Box>
    );
  }
);
